// Types
import { ErrorNames } from './ErrorNames';
/**
 * @description Returns an instance of error with the name set to UnresolvableDataError
 *              This should be used when data exists but it cannot be resolved due to shape/missing properties
 *
 * @return { Error } error with name set to UnresolvableDataError
 */
export var getUnresolvableDataError = function () {
    var error = new Error();
    error.name = ErrorNames.UNRESOLVABLE_DATA;
    return error;
};
//# sourceMappingURL=getUnresolvableDataError.js.map